function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "\\u30B7\\u30A7\\u30A4\\u30D7 1",
  d: "M4.363 10.639L.183 6.018a.845.845 0 010-1.132l4.18-4.62a.841.841 0 111.243 1.131L1.939 5.452l3.667 4.054a.844.844 0 01-.058 1.189.838.838 0 01-1.185-.056z",
  fill: "#008ce6",
  fillRule: "evenodd"
});

var SvgIconBack = function SvgIconBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5.844 10.906"
  }, props), _ref);
};

export default SvgIconBack;